import { isBrowser } from 'env'
const lockers = []

let scrollPos = null

// WORKAROUND: bodyScrolling lock/release has a side-effect: it causes 'scroll' events being fired on document element.
// This causes unwanted execution of callbacks on document element scroll event.
// The below function is a replacement of document.addEventListener('scroll', someCallback).
// It checks if scroll event is due to bodyScrolling lock/release before executing the callback.
export const registerPageScrollEventListener = (callback, useCapture = false) => {
  const isPageScrolled = () => {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    return (scrollPos === null) || !((document.body.style.position === 'fixed') || (scrollTop === scrollPos))
  }

  const scrollEventListener = (e) => {
    if (isPageScrolled()) {
      callback(e)
    }
  }

  document.addEventListener('scroll', scrollEventListener, useCapture)

  return () => document.removeEventListener('scroll', scrollEventListener)
}

const saveScrollPosition = () => {
  const doc = document.documentElement
  scrollPos = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)
}

const resetScrollPosition = () => window.scrollTo(0, scrollPos)

const lockBodyScroll = () => {
  if (isBrowser()) {
    saveScrollPosition()
    document.body.setAttribute('style', `position: fixed; top: ${-scrollPos}px; left: 0; width: 100%; overflow: hidden;`)
  }
}

const releaseBodyScroll = () => {
  if (isBrowser() && lockers.length === 0) {
    document.body.setAttribute('style', '')
    resetScrollPosition()
  }
}

export const lock = (elementId) => {
  if (!lockers.includes(elementId)) {
    lockers.push(elementId)
    lockBodyScroll()
  }
}

export const release = (elementId) => {
  if (lockers.includes(elementId)) {
    lockers.splice(lockers.indexOf(elementId), 1)
    releaseBodyScroll()
  }
}
